/* global $ */
import { throttleDomAfterAsync } from '../helpers/throttle';

if ($.$body.hasClass('has-overlay-search')) {
	const $searchOverlay = $.$body.find('.search-overlay');
	const $searchInput = $.$body.find('.search__input');
	const openSearch = (e) => {
		// console.log(e);
		e.preventDefault();
		$searchOverlay.addClass('search--open temp-high-z');
		$searchInput.focus();
		if ($searchInput.val()) {
			$searchInput.select();
		}
		$searchOverlay.prop('hidden', false);
		$searchOverlay.attr('aria-hidden', 'false');
	};
	const closeSearch = (e) => {
		e.preventDefault();
		$searchOverlay.removeClass('search--open');
		$searchInput.blur();
		$searchOverlay.attr('attr-hidden', 'true');
		$searchOverlay.prop('hidden', true);
		setTimeout(() => {
			$searchOverlay.removeClass('temp-high-z');
		}, 100);
	};
	$.$body
		.on('click', '.js-open-site-search', openSearch)
		.on('click', '.js-close-site-search', closeSearch);
	document.addEventListener('keyup', (e) => {
		if (e.keyCode === 27) {
			closeSearch(e);
		}
	});
} else if ($.$body.hasClass('has-pulldown-search')) {
	// pulldown search

	const $topSearch = $.$body.find('.top-search');

	const throttledInputChange = throttleDomAfterAsync((e) => {
		const searchInputValue = String($(e.target).val()).length;
		$(e.currentTarget)
			.closest('.search__form')
			.toggleClass('has-value', searchInputValue > 1);
	}, 200);

	const closeSearch = () => {
		$topSearch
			.attr('aria-hidden', true)
			.prop('hidden', true)
			.find('.search__input')
			.blur();
		$.$body.removeClass('search-open temp-high-z');
	};

	const removeOnEscape = (e) => {
		if (e.keyCode === 27) {
			closeSearch();
		}
	};

	$.$body.on('click', '.js-open-site-search', (e) => {
		e.preventDefault();
		e.stopPropagation();
		$.$body.toggleClass('search-open');
		$topSearch
			.attr('aria-hidden', false)
			.prop('hidden', false)
			.find('.search__input')
			.focus()
			.select();
	});

	$.$body.on('input', '.search__input', throttledInputChange);

	// allow closing with escape key
	$(document).on('keyup', removeOnEscape);

	// close if any clicks fall outside the search
	$(document).on('click', (e) => {
		if (! $topSearch.is(e.target) && $topSearch.has(e.target).length === 0) {
			closeSearch();
		}
	});
}

// Prevent empty searches on older browsers
$.$body.on('submit', '[data-searchform]', (e) => {
	const searchInputValue = $(e.target).find('.site-search-field').val();
	if (searchInputValue === '') {
		e.preventDefault();
	}
});
